import { render, staticRenderFns } from "./IconHamburger.vue?vue&type=template&id=6cca54d0&"
var script = {}
import style0 from "./IconHamburger.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cca54d0')) {
      api.createRecord('6cca54d0', component.options)
    } else {
      api.reload('6cca54d0', component.options)
    }
    module.hot.accept("./IconHamburger.vue?vue&type=template&id=6cca54d0&", function () {
      api.rerender('6cca54d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/IconHamburger.vue"
export default component.exports